import { createBlueprint as e } from "@made-people/blueprint";
const t = e({
  slots: {
    wrapper: "",
    imageWrapper: "",
    image: "",
    content: "",
    text: "",
    link: ""
  },
  variants: {
    layout: {
      vertical: {
        wrapper: "flex flex-col"
      },
      horizontal: {
        wrapper: "flex flex-row"
      },
      horizontalReverse: {
        wrapper: "flex flex-row-reverse"
      },
      verticalReverse: {
        wrapper: "flex flex-col-reverse"
      },
      sizeGuide: {
        wrapper: ""
      }
    },
    backgroundColor: {
      white: { content: "" },
      purple: { content: "" },
      // wp
      yellow: { content: "" }
      // wp
    },
    foregroundColor: {
      black: { content: "" },
      purple: { content: "" },
      // wp
      yellow: { content: "" }
      // wp
    },
    contentAlignment: {
      left: {
        content: "items-start text-left"
      },
      center: {
        content: "items-center text-center"
      }
    },
    textSpacing: {
      none: {
        content: "px-0"
      }
    },
    aspectRatio: {
      square: {
        imageWrapper: "aspect-square",
        image: "object-cover"
      },
      default: {
        imageWrapper: "aspect-auto",
        image: "object-cover"
      },
      original: {
        imageWrapper: "aspect-auto",
        image: "object-cover aspect-auto"
      }
    }
  }
}), o = {
  main: t
};
export {
  o as template1Styling
};
//# sourceMappingURL=index-blueprint.es.js.map
